import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown } from 'lucide-react';

export default function StatCard({ icon: Icon, title, value, delay = 0, delta, deltaLabel, detail, period }) {
  const isPositive = delta === undefined ? null : delta >= 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay, ease: 'easeOut' }}
      className="card-metric p-5 cursor-pointer group"
    >
      {/* En-tête : icône + badge période */}
      <div className="flex items-start justify-between mb-3">
        <div
          className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
          style={{ background: 'rgba(var(--c-accent-green-rgb), 0.12)' }}
        >
          <Icon size={18} style={{ color: 'rgb(var(--c-accent-green-rgb))' }} strokeWidth={1.5} />
        </div>

        {period && (
          <span style={{
            fontSize: '10px',
            fontWeight: 500,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            color: 'var(--c-text-muted)',
            paddingTop: '3px',
            fontFamily: 'Inter, sans-serif',
          }}>
            {period}
          </span>
        )}
      </div>

      {/* Label */}
      <p className="text-label mb-1.5">{title}</p>

      {/* Valeur principale — DM Mono */}
      <p
        className="font-metric text-ink mb-2"
        style={{ fontSize: '28px', fontWeight: 600, lineHeight: 1, letterSpacing: '-0.02em' }}
      >
        {value}
      </p>

      {/* Delta OU détail contextuel */}
      {delta !== undefined ? (
        <div className="flex items-center gap-1">
          {isPositive ? (
            <TrendingUp size={12} style={{ color: 'rgb(var(--c-accent-green-rgb))' }} />
          ) : (
            <TrendingDown size={12} style={{ color: 'var(--c-error)' }} />
          )}
          <span
            className="text-label"
            style={{
              color: isPositive ? 'rgb(var(--c-accent-green-rgb))' : 'var(--c-error)',
              letterSpacing: '0.02em',
            }}
          >
            {isPositive ? '+' : ''}{delta}% {deltaLabel || 'vs hier'}
          </span>
        </div>
      ) : detail ? (
        <div className="flex items-center gap-1.5">
          <div style={{
            width: '3px',
            height: '3px',
            borderRadius: '50%',
            background: 'var(--c-text-muted)',
            flexShrink: 0,
          }} />
          <span className="text-label">{detail}</span>
        </div>
      ) : (
        <div style={{ height: '16px' }} />
      )}
    </motion.div>
  );
}
